/* 
AUTO GENERATED. USE 'make config' TO UPDATE. 
SEE 'config.mustache' for the template.
*/
interface EndpointConfig {
  graphqlEndPoint: string;
}
interface AppConfig {
  ciRevision: string;
  ciRef: string;
  cognito: {
    REGION: string;
    USER_POOL_ID: string;
    APP_CLIENT_ID: string;
    IDENTITY_POOL_ID: string;
  };
  backend: EndpointConfig;
  connx: EndpointConfig;
  connxevents: EndpointConfig;
  analytics: {
    enabled: boolean;
  };
}
const getConfig = (): AppConfig => {
  return {
    ciRevision: "1efedd03",
    ciRef: "v1-4-8",
    cognito: {
      REGION: "ap-southeast-2",
      USER_POOL_ID: "ap-southeast-2_i62JHHVGP",
      APP_CLIENT_ID: "ldg91qas15l0q9mk2j27vondv",
      IDENTITY_POOL_ID: "ap-southeast-2:61c636ed-6545-495a-acc7-d6fa00fffbab",
    },
    backend: {
      graphqlEndPoint:
        "https://f3ybp1cs3i.execute-api.ap-southeast-2.amazonaws.com",
    },
    connx: {
      graphqlEndPoint:
        "https://hdpl2pbz47.execute-api.ap-southeast-2.amazonaws.com",
    },
    connxevents: {
      graphqlEndPoint:
        "https://9nu3xrw1ie.execute-api.ap-southeast-2.amazonaws.com",
    },
    analytics: { enabled: true },
  };
};
export default getConfig;
